module.exports = __webpack_public_path__ + "static/Model-Car-47f784f3721d607544c32838f2e44b5a.png";